var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicStick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4.00001C14 2.8954 14.8954 2 16 2C14.8955 2 14 1.10457 14 0C14 1.10454 13.1046 2 12 2C13.1045 2 14 2.89537 14 4.00001Z",
    fill: "url(#paint0_linear_381_2242)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6C14.5 6.82841 13.8284 7.49999 13 7.49999C13.8284 7.49999 14.5 8.17158 14.5 8.99999C14.5 8.17154 15.1716 7.49999 16 7.49999C15.1715 7.50003 14.5 6.82845 14.5 6Z",
    fill: "url(#paint1_linear_381_2242)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99999 5.99998C6.99999 4.34312 8.34312 2.99999 9.99998 2.99999C8.34312 2.99999 6.99999 1.65686 6.99999 0C6.99999 1.65686 5.65686 2.99999 4 2.99999C5.65686 2.99999 6.99999 4.34315 6.99999 5.99998Z",
    fill: "url(#paint2_linear_381_2242)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3L0 14L2 16L13 5L11 3ZM9.29296 6.20703L10.707 4.79299L11.207 5.293L9.79297 6.70704L9.29296 6.20703Z",
    fill: "url(#paint3_linear_381_2242)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_381_2242",
    x1: 12.7133,
    y1: 0.733335,
    x2: 15.8429,
    y2: 2.85435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_381_2242",
    x1: 13.535,
    y1: 6.55,
    x2: 15.8821,
    y2: 8.14075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_381_2242",
    x1: 5.07,
    y1: 1.1,
    x2: 9.76427,
    y2: 4.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_381_2242",
    x1: 2.31833,
    y1: 5.38333,
    x2: 12.4893,
    y2: 12.2766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FB8C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7977F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicStick);
export default __webpack_public_path__ + "static/media/magic_stick.1c280064462a6696f481114d0db063bf.svg";
export { ForwardRef as ReactComponent };